import PasswordNotification from './password-notification.vue';

export default PasswordNotification;
